import type { MenuSecaoAcoesComplementares } from '@Lar21/imaginii-web-components/lib/vue/vue'
import fotoNina from '@/../static/images/nina.png'

interface OpcoesDaAjuda {
  compacto: boolean
  ninaDisponivel: boolean
  suporteDisponivel: boolean
  abrindoSuporte: boolean
  t: (chave: string) => string
  abrirNina: () => void
  abrirSuporte: () => void
}

const iconeSuporte = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v12H9l-5 4V4Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>'

export function criarSecaoAjuda (opcoes: OpcoesDaAjuda): MenuSecaoAcoesComplementares | undefined {
  if (!opcoes.compacto) return undefined
  const itens: MenuSecaoAcoesComplementares['itens'] = []
  if (opcoes.ninaDisponivel) itens.push({
    id: 'nina',
    titulo: opcoes.t('MenuLateral.ajuda.nina'),
    descricao: opcoes.t('MenuLateral.ajuda.descricaoNina'),
    avatar: fotoNina,
    destaque: true,
    acao: opcoes.abrirNina
  })
  if (opcoes.suporteDisponivel) itens.push({
    id: 'suporte',
    titulo: opcoes.t('MenuLateral.ajuda.suporte'),
    descricao: opcoes.t('MenuLateral.ajuda.descricaoSuporte'),
    icone: iconeSuporte,
    carregando: opcoes.abrindoSuporte,
    acao: opcoes.abrirSuporte
  })
  return itens.length ? { titulo: opcoes.t('MenuLateral.ajuda.titulo'), itens } : undefined
}
